import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { InstructionCSSClasses } from './tools/types';

/* eslint-disable max-len, @typescript-eslint/quotes */

const useStyles = makeStyles(({ colors, palette }: Theme) => createStyles({
  editor: {
    borderRadius: 4,
    border: `solid 1px ${colors.border}`,
    overflow: 'auto',
    maxHeight: 'calc(100vh - 500px)',
    minHeight: 200,
    '& > .codex-editor': {

    },
    '& .cdx-settings-button, .ce-settings__button': {
      color: '#747C99',
    },
    '& .codex-editor__redactor': {
      paddingTop: 10,
      paddingBottom: '50px !important',
      margin: 'unset !important',
      minHeight: '100%',
    },
    '& .cdx-block[contenteditable="true"]': {
      padding: '5px 20px !important',
    },
    '& .ce-block__content': {
      maxWidth: 'unset',
    },
    '& .ce-header': {
      paddingTop: '10px !important',
      paddingBottom: '15px !important',
      paddingLeft: '20px !important',
      paddingRight: '20px !important',
    },
    '& .ce-inline-tool': {
      color: '#515B6A',
      alignItems: 'center',
    },
    '& .ce-toolbox--opened': {
      left: 20,
      right: 34,
      backgroundColor: '#fff',
    },
    '& .ce-settings': {
      top: 30,
    },
    [`& .ce-toolbox__button[data-tool="table"], .ce-toolbox__button[data-tool="warning"],
      .ce-toolbox__button[data-tool="code"], .ce-toolbox__button[data-tool="linkTool"],
      .ce-toolbox__button[data-tool="image"], .ce-toolbox__button[data-tool="raw"],
      .ce-toolbox__button[data-tool="quote"], .ce-toolbox__button[data-tool="delimiter"],
      .ce-inline-tool--bold, .ce-inline-tool--italic`]: {
      display: 'none',
    },
    [`& .ce-inline-tool[data-tool="link"], .ce-inline-tool[data-tool="marker"]`]: {
      display: 'none',
    },
    '& .ce-block.ce-block--focused': {
      marginRight: '0 !important',
      paddingRight: '0 !important',
    },
    '& .ce-toolbar': {
      background: 'unset !important',
      boxShadow: 'unset !important',
      border: 'unset !important',
      zIndex: 'unset',
      padding: 'unset',
      margin: 'unset',
    },
    '& .ce-toolbox': {
      position: 'absolute',
    },
    '& .ce-toolbar__actions': {
      right: 0,
      top: 5,
      transform: 'unset',
    },
    '& .ce-toolbar__content': {
      maxWidth: 'unset',
      position: 'unset',
    },
    '& .ce-toolbar__plus': {
      left: -5,
      position: 'absolute',
    },
    '& .ce-settings--opened': {
      right: 0,
    },
    '& .ce-toolbar__actions ce-toolbar__actions--opened': {
      right: 4,
    },

    // INSTRUCTION TOOLTIP
    [`& .${InstructionCSSClasses.INSTRUCTION_TOOLTIP}`]: {
      position: 'absolute',
      zIndex: 1,
      background: palette.tooltip.background,
      color: palette.tooltip.color,
      fontSize: 12,
      fontFamily: 'Roboto',
      padding: '2px 4px',
      borderRadius: 3,
      lineHeight: '1.5em',
      maxWidth: 150,
      width: 'max-content',
      display: 'inline-block',
      boxShadow: '-1px 1px 4px 0px rgba(0,0,0,0.4)',
      wordBreak: 'break-all',
    },

    // INSTRUCTION STYLES
    [`& .${InstructionCSSClasses.BLOCK_INSTRUCTION_ACTION}, .${InstructionCSSClasses.INLINE_INSTRUCTION_ACTION}`]: {
      display: 'inline-block',
      width: 22,
      height: 22,
      borderStyle: 'solid',
      borderWidth: 1,
      borderRadius: 3,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      cursor: 'pointer',
      backgroundSize: '80%',
      position: 'relative',
      textAlign: 'center',
      '&::before': {
        fontSize: 16,
        fontWeight: 'bold',
      },
    },
    [`& .${InstructionCSSClasses.BLOCK_INSTRUCTION_WRAPPER}`]: {
      fontFamily: 'Roboto',
      borderRadius: 3,
      outline: 'none',
      margin: '5px 20px',
      padding: 5,
      borderStyle: 'solid',
      borderWidth: 1,
    },
    [`& .${InstructionCSSClasses.BLOCK_INSTRUCTION_CONTENT}`]: {
      outline: 'none',
      minHeight: 20,
    },
    [`& .${InstructionCSSClasses.BLOCK_INSTRUCTION_ACTION}`]: {
      float: 'left',
      marginRight: 5,
    },
    [`& .${InstructionCSSClasses.INLINE_INSTRUCTION_WRAPPER}`]: {
      fontFamily: 'Roboto',
    },
    [`& .${InstructionCSSClasses.INLINE_INSTRUCTION_CONTENT}`]: {
      marginLeft: 3,
      outline: 'none',
      borderBottomStyle: 'solid',
      borderBottomWidth: 1,
    },

    // IMAGE INSTRUCTION
    [`& .${InstructionCSSClasses.IMAGE_INSTRUCTION_ACTION}, .${InstructionCSSClasses.IMAGE_INSTRUCTION_BLOCK_ACTION}`]: {
      backgroundImage: `url("data:image/svg+xml,%3Csvg aria-hidden='true' focusable='false' data-prefix='far' data-icon='image' class='svg-inline--fa fa-image fa-w-16' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' %3E%3Cpath fill='%238324B2' d='M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm-6 336H54a6 6 0 0 1-6-6V118a6 6 0 0 1 6-6h404a6 6 0 0 1 6 6v276a6 6 0 0 1-6 6zM128 152c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zM96 352h320v-80l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L192 304l-39.515-39.515c-4.686-4.686-12.284-4.686-16.971 0L96 304v48z'%3E%3C/path%3E%3C/svg%3E")`,
      backgroundColor: palette.imageInstruction.background,
      borderColor: palette.imageInstruction.border,
    },
    [`& .${InstructionCSSClasses.IMAGE_INSTRUCTION_BLOCK}`]: {
      borderColor: palette.imageInstruction.border,
      background: palette.imageInstruction.background,
    },
    [`& .${InstructionCSSClasses.IMAGE_INSTRUCTION_CONTENT}`]: {
      borderColor: palette.imageInstruction.border,
    },

    // TEXT OVERLAY INSTRUCTION
    [`& .${InstructionCSSClasses.TEXT_INSTRUCTION_ACTION}, .${InstructionCSSClasses.TEXT_INSTRUCTION_BLOCK_ACTION}`]: {
      backgroundImage: `url("data:image/svg+xml,%3Csvg aria-hidden='true' focusable='false' data-prefix='far' data-icon='comment-alt' class='svg-inline--fa fa-comment-alt fa-w-16' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath fill='%23EFC400' d='M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 7.1 5.8 12 12 12 2.4 0 4.9-.7 7.1-2.4L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm16 352c0 8.8-7.2 16-16 16H288l-12.8 9.6L208 428v-60H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v288z'%3E%3C/path%3E%3C/svg%3E")`,
      backgroundColor: palette.textInstruction.background,
      borderColor: palette.textInstruction.actionBorder,
    },
    [`& .${InstructionCSSClasses.TEXT_INSTRUCTION_CONTENT}`]: {
      borderColor: palette.textInstruction.border,
    },
    [`& .${InstructionCSSClasses.TEXT_INSTRUCTION_BLOCK}`]: {
      borderColor: palette.textInstruction.border,
      background: palette.textInstruction.background,
    },

    // NOTE INSTRUCTION
    [`& .${InstructionCSSClasses.NOTE_INSTRUCTION_ACTION}, .${InstructionCSSClasses.NOTE_INSTRUCTION_BLOCK_ACTION}`]: {
      backgroundImage: `url("data:image/svg+xml,%3Csvg aria-hidden='true' focusable='false' data-prefix='far' data-icon='sticky-note' class='svg-inline--fa fa-sticky-note fa-w-14' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512'%3E%3Cpath fill='%23747C99' d='M448 348.106V80c0-26.51-21.49-48-48-48H48C21.49 32 0 53.49 0 80v351.988c0 26.51 21.49 48 48 48h268.118a48 48 0 0 0 33.941-14.059l83.882-83.882A48 48 0 0 0 448 348.106zm-128 80v-76.118h76.118L320 428.106zM400 80v223.988H296c-13.255 0-24 10.745-24 24v104H48V80h352z'%3E%3C/path%3E%3C/svg%3E")`,
      backgroundColor: palette.noteInstruction.background,
      borderColor: palette.noteInstruction.border,

    },
    [`& .${InstructionCSSClasses.NOTE_INSTRUCTION_CONTENT}`]: {
      borderColor: palette.noteInstruction.border,
    },
    [`& .${InstructionCSSClasses.NOTE_INSTRUCTION_BLOCK}`]: {
      borderColor: palette.noteInstruction.border,
      background: palette.noteInstruction.background,
    },
    [`& .${InstructionCSSClasses.NOTE_INSTRUCTION_BLOCK} a`]: {
      color: palette.link.color,
    },

    // VIDEO INSTRUCTION
    [`& .${InstructionCSSClasses.VIDEO_INSTRUCTION_ACTION}, .${InstructionCSSClasses.VIDEO_INSTRUCTION_BLOCK_ACTION}`]: {
      backgroundImage: `url("data:image/svg+xml,%3Csvg aria-hidden='true' focusable='false' data-prefix='far' data-icon='file-video' class='svg-inline--fa fa-file-video fa-w-12' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 384 512'%3E%3Cpath fill='%2300AD8D' d='M369.941 97.941l-83.882-83.882A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v416c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48V131.882a48 48 0 0 0-14.059-33.941zM332.118 128H256V51.882L332.118 128zM48 464V48h160v104c0 13.255 10.745 24 24 24h104v288H48zm228.687-211.303L224 305.374V268c0-11.046-8.954-20-20-20H100c-11.046 0-20 8.954-20 20v104c0 11.046 8.954 20 20 20h104c11.046 0 20-8.954 20-20v-37.374l52.687 52.674C286.704 397.318 304 390.28 304 375.986V264.011c0-14.311-17.309-21.319-27.313-11.314z'%3E%3C/path%3E%3C/svg%3E")`,
      backgroundColor: palette.videoInstruction.background,
      borderColor: palette.videoInstruction.border,
      backgroundSize: '60%',
    },
    [`& .${InstructionCSSClasses.VIDEO_INSTRUCTION_CONTENT}`]: {
      borderColor: palette.videoInstruction.border,
    },
    [`& .${InstructionCSSClasses.VIDEO_INSTRUCTION_BLOCK}`]: {
      borderColor: palette.videoInstruction.border,
      background: palette.videoInstruction.background,
    },

    // AUDIO INSTRUCTION
    [`& .${InstructionCSSClasses.AUDIO_INSTRUCTION_ACTION}, .${InstructionCSSClasses.AUDIO_INSTRUCTION_BLOCK_ACTION}`]: {
      backgroundImage: `url("data:image/svg+xml,%3Csvg aria-hidden='true' focusable='false' data-prefix='far' data-icon='file-audio' class='svg-inline--fa fa-file-audio fa-w-12' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 384 512'%3E%3Cpath fill='%2300AD8D' d='M369.941 97.941l-83.882-83.882A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v416c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48V131.882a48 48 0 0 0-14.059-33.941zM332.118 128H256V51.882L332.118 128zM48 464V48h160v104c0 13.255 10.745 24 24 24h104v288H48zm144-76.024c0 10.691-12.926 16.045-20.485 8.485L136 360.486h-28c-6.627 0-12-5.373-12-12v-56c0-6.627 5.373-12 12-12h28l35.515-36.947c7.56-7.56 20.485-2.206 20.485 8.485v135.952zm41.201-47.13c9.051-9.297 9.06-24.133.001-33.439-22.149-22.752 12.235-56.246 34.395-33.481 27.198 27.94 27.212 72.444.001 100.401-21.793 22.386-56.947-10.315-34.397-33.481z'%3E%3C/path%3E%3C/svg%3E")`,
      backgroundColor: palette.videoInstruction.background,
      borderColor: palette.videoInstruction.border,
      backgroundSize: '60%',
    },
    [`& .${InstructionCSSClasses.AUDIO_INSTRUCTION_CONTENT}`]: {
      borderColor: palette.videoInstruction.border,
    },
    [`& .${InstructionCSSClasses.AUDIO_INSTRUCTION_BLOCK}`]: {
      borderColor: palette.videoInstruction.border,
      background: palette.videoInstruction.background,
    },

    // TITLE INSTRUCTION
    [`& .${InstructionCSSClasses.TITLE_INSTRUCTION_ACTION}, .${InstructionCSSClasses.TITLE_INSTRUCTION_BLOCK_ACTION}`]: {
      backgroundImage: `url("data:image/svg+xml,%3Csvg aria-hidden='true' focusable='false' data-prefix='far' data-icon='address-card' class='svg-inline--fa fa-address-card fa-w-18' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 576 512'%3E%3Cpath fill='%23EFC400' d='M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 400H48V80h480v352zM208 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm-89.6 128h179.2c12.4 0 22.4-8.6 22.4-19.2v-19.2c0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6v19.2c0 10.6 10 19.2 22.4 19.2zM360 320h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8z'%3E%3C/path%3E%3C/svg%3E")`,
      backgroundColor: palette.textInstruction.background,
      borderColor: palette.textInstruction.actionBorder,
    },
    [`& .${InstructionCSSClasses.TITLE_INSTRUCTION_CONTENT}`]: {
      borderColor: palette.textInstruction.border,
    },
    [`& .${InstructionCSSClasses.TITLE_INSTRUCTION_BLOCK}`]: {
      borderColor: palette.textInstruction.border,
      background: palette.textInstruction.background,
    },

    // NAME IN SCRIPT INSTRUCTION
    [`& .${InstructionCSSClasses.NAME_SCRIPT_INSTRUCTION_ACTION}, .${InstructionCSSClasses.NAME_SCRIPT_INSTRUCTION_BLOCK_ACTION}`]: {
      backgroundImage: `url("data:image/svg+xml,%3Csvg aria-hidden='true' focusable='false' data-prefix='far' data-icon='user-circle' class='svg-inline--fa fa-user-circle fa-w-16' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 496 512'%3E%3Cpath fill='%23EFC400' d='M248 104c-53 0-96 43-96 96s43 96 96 96 96-43 96-96-43-96-96-96zm0 144c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-240C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-49.7 0-95.1-18.3-130.1-48.4 14.9-23 40.4-38.6 69.6-39.5 20.8 6.4 40.6 9.6 60.5 9.6s39.7-3.1 60.5-9.6c29.2 1 54.7 16.5 69.6 39.5-35 30.1-80.4 48.4-130.1 48.4zm162.7-84.1c-24.4-31.4-62.1-51.9-105.1-51.9-10.2 0-26 9.6-57.6 9.6-31.5 0-47.4-9.6-57.6-9.6-42.9 0-80.6 20.5-105.1 51.9C61.9 339.2 48 299.2 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 43.2-13.9 83.2-37.3 115.9z'%3E%3C/path%3E%3C/svg%3E")`,
      backgroundColor: palette.textInstruction.background,
      borderColor: palette.textInstruction.actionBorder,
    },
    [`& .${InstructionCSSClasses.NAME_SCRIPT_INSTRUCTION_CONTENT}`]: {
      borderColor: palette.textInstruction.border,
    },
    [`& .${InstructionCSSClasses.NAME_SCRIPT_INSTRUCTION_BLOCK}`]: {
      borderColor: palette.textInstruction.border,
      background: palette.textInstruction.background,
    },

    // WEB PAGE INSTRUCTION
    [`& .${InstructionCSSClasses.WEB_PAGE_INSTRUCTION_ACTION}, .${InstructionCSSClasses.WEB_PAGE_INSTRUCTION_BLOCK_ACTION}`]: {
      backgroundImage: `url("data:image/svg+xml,%3Csvg aria-hidden='true' focusable='false' data-prefix='fas' data-icon='link' class='svg-inline--fa fa-link fa-w-16' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath fill='%238324B2' d='M326.612 185.391c59.747 59.809 58.927 155.698.36 214.59-.11.12-.24.25-.36.37l-67.2 67.2c-59.27 59.27-155.699 59.262-214.96 0-59.27-59.26-59.27-155.7 0-214.96l37.106-37.106c9.84-9.84 26.786-3.3 27.294 10.606.648 17.722 3.826 35.527 9.69 52.721 1.986 5.822.567 12.262-3.783 16.612l-13.087 13.087c-28.026 28.026-28.905 73.66-1.155 101.96 28.024 28.579 74.086 28.749 102.325.51l67.2-67.19c28.191-28.191 28.073-73.757 0-101.83-3.701-3.694-7.429-6.564-10.341-8.569a16.037 16.037 0 0 1-6.947-12.606c-.396-10.567 3.348-21.456 11.698-29.806l21.054-21.055c5.521-5.521 14.182-6.199 20.584-1.731a152.482 152.482 0 0 1 20.522 17.197zM467.547 44.449c-59.261-59.262-155.69-59.27-214.96 0l-67.2 67.2c-.12.12-.25.25-.36.37-58.566 58.892-59.387 154.781.36 214.59a152.454 152.454 0 0 0 20.521 17.196c6.402 4.468 15.064 3.789 20.584-1.731l21.054-21.055c8.35-8.35 12.094-19.239 11.698-29.806a16.037 16.037 0 0 0-6.947-12.606c-2.912-2.005-6.64-4.875-10.341-8.569-28.073-28.073-28.191-73.639 0-101.83l67.2-67.19c28.239-28.239 74.3-28.069 102.325.51 27.75 28.3 26.872 73.934-1.155 101.96l-13.087 13.087c-4.35 4.35-5.769 10.79-3.783 16.612 5.864 17.194 9.042 34.999 9.69 52.721.509 13.906 17.454 20.446 27.294 10.606l37.106-37.106c59.271-59.259 59.271-155.699.001-214.959z'%3E%3C/path%3E%3C/svg%3E");`,
      backgroundColor: palette.imageInstruction.background,
      borderColor: palette.imageInstruction.border,
    },
    [`& .${InstructionCSSClasses.WEB_PAGE_INSTRUCTION_BLOCK}`]: {
      borderColor: palette.imageInstruction.border,
      background: palette.imageInstruction.background,
    },
    [`& .${InstructionCSSClasses.WEB_PAGE_INSTRUCTION_CONTENT}`]: {
      borderColor: palette.imageInstruction.border,
    },

    // DOCUMENT PAGE INSTRUCTION
    [`& .${InstructionCSSClasses.DOCUMENT_PAGE_INSTRUCTION_ACTION}, .${InstructionCSSClasses.DOCUMENT_PAGE_INSTRUCTION_BLOCK_ACTION}`]: {
      backgroundImage: `url("data:image/svg+xml,%3Csvg aria-hidden='true' focusable='false' data-prefix='far' data-icon='file-powerpoint' class='svg-inline--fa fa-file-powerpoint fa-w-12' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 384 512'%3E%3Cpath fill='%238324B2' d='M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm72-60V236c0-6.6 5.4-12 12-12h69.2c36.7 0 62.8 27 62.8 66.3 0 74.3-68.7 66.5-95.5 66.5V404c0 6.6-5.4 12-12 12H132c-6.6 0-12-5.4-12-12zm48.5-87.4h23c7.9 0 13.9-2.4 18.1-7.2 8.5-9.8 8.4-28.5.1-37.8-4.1-4.6-9.9-7-17.4-7h-23.9v52z'%3E%3C/path%3E%3C/svg%3E")`,
      backgroundColor: palette.imageInstruction.background,
      borderColor: palette.imageInstruction.border,
      backgroundSize: '60%',
    },
    [`& .${InstructionCSSClasses.DOCUMENT_PAGE_INSTRUCTION_BLOCK}`]: {
      borderColor: palette.imageInstruction.border,
      background: palette.imageInstruction.background,
    },
    [`& .${InstructionCSSClasses.DOCUMENT_PAGE_INSTRUCTION_CONTENT}`]: {
      borderColor: palette.imageInstruction.border,
    },
    '& .exclamationIcon': {
      position: 'absolute',
      backgroundImage: `url("data:image/svg+xml,%3Csvg aria-hidden='true' focusable='false' data-prefix='far' data-icon='exclamation-circle' class='svg-inline--fa fa-exclamation-circle fa-w-12' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath fill='%23FF6C00' d='M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z'%3E%3C/path%3E%3C/svg%3E")`,
      backgroundColor: '#fff',
      top: -9,
      left: -9,
      width: 12,
      height: 12,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      borderColor: palette.imageInstruction.border,
      borderRadius: '100%',
    },
  },

  // SCRIPT PREVIEW
  scriptPreview: {
    borderRadius: 4,
    border: `solid 1px ${colors.border}`,
    overflow: 'auto',
    padding: '10px 20px',
    maxHeight: 'calc(100vh - 550px)',
    '& .ce-block__content': {
      maxWidth: 'unset',
    },
  },
}), { name: 'ScriptEditor' });

export default useStyles;
